import { faTriangleExclamation as WarningIcon } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';

import useStyles from './NotFound.styles';

export const NotFound = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.notFound}>
      <Paper elevation={3} className={classes.paper}>
        <FontAwesomeIcon
          icon={WarningIcon}
          size="4x"
          style={{ marginBottom: '1rem' }}
        />
        <Typography variant="h1">404</Typography>
        <Typography variant="body1">Page Not Found</Typography>
        <br />
        <Button
          variant="contained"
          color="primary"
          href="/tickets"
          component={Link}
          to="/tickets"
        >
          Back to Tickets
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
